/**
 * Horizontal carousels: centered snap (featured collection / related) or simple scroll-by-slide-width (brand manifesto).
 */
(function () {
  'use strict';

  var boundRoots = new WeakSet();

  function getConfig(root) {
    var simple = root.getAttribute('data-carousel-simple') === 'true';
    var slideSelector =
      root.getAttribute('data-carousel-slide-selector') || '.section-featured-collection__carousel-slide';
    var initialRaw = root.getAttribute('data-carousel-initial-index');
    var initialIndex;
    if (initialRaw === null || initialRaw === '') {
      initialIndex = simple ? 0 : 1;
    } else {
      var parsed = parseInt(initialRaw, 10);
      initialIndex = isNaN(parsed) ? (simple ? 0 : 1) : parsed;
    }
    return {
      simple: simple,
      slideSelector: slideSelector,
      initialIndex: initialIndex,
    };
  }

  function getSlides(track, slideSelector) {
    return Array.prototype.slice.call(track.querySelectorAll(slideSelector));
  }

  function closestSlideIndexToCenter(track, slides) {
    var trackRect = track.getBoundingClientRect();
    var centerX = trackRect.left + trackRect.width / 2;
    var bestIdx = 0;
    var bestDist = Infinity;
    slides.forEach(function (slide, i) {
      var r = slide.getBoundingClientRect();
      var slideCenter = r.left + r.width / 2;
      var d = Math.abs(slideCenter - centerX);
      if (d < bestDist) {
        bestDist = d;
        bestIdx = i;
      }
    });
    return bestIdx;
  }

  function scrollToIndex(track, slideSelector, index, smooth) {
    var slides = getSlides(track, slideSelector);
    var slide = slides[index];
    if (!slide) return;
    var slideRect = slide.getBoundingClientRect();
    var trackRect = track.getBoundingClientRect();
    var slideCenter = slideRect.left + slideRect.width / 2;
    var trackCenter = trackRect.left + trackRect.width / 2;
    var delta = slideCenter - trackCenter;
    if (!smooth) {
      track.scrollLeft += delta;
      return;
    }
    try {
      track.scrollBy({ left: delta, top: 0, behavior: 'smooth' });
    } catch (e) {
      track.scrollLeft += delta;
    }
  }

  function scrollToAdjacent(track, slideSelector, direction) {
    var slides = getSlides(track, slideSelector);
    if (slides.length < 1) return;
    var i = closestSlideIndexToCenter(track, slides);
    var nextIndex;
    if (direction === 'next') {
      nextIndex = i + 1 >= slides.length ? 0 : i + 1;
    } else {
      nextIndex = i - 1 < 0 ? slides.length - 1 : i - 1;
    }
    scrollToIndex(track, slideSelector, nextIndex, true);
  }

  function onFeaturedCarouselClick(e) {
    var root = e.currentTarget;
    if (!e.target.closest('[data-carousel-prev]') && !e.target.closest('[data-carousel-next]')) return;
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var cfg = getConfig(root);
    var slides = getSlides(track, cfg.slideSelector);
    if (slides.length < 1) return;
    if (e.target.closest('[data-carousel-prev]')) {
      scrollToAdjacent(track, cfg.slideSelector, 'prev');
    }
    if (e.target.closest('[data-carousel-next]')) {
      scrollToAdjacent(track, cfg.slideSelector, 'next');
    }
  }

  function onSimpleCarouselClick(e) {
    var root = e.currentTarget;
    if (!e.target.closest('[data-carousel-prev]') && !e.target.closest('[data-carousel-next]')) return;
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var cfg = getConfig(root);
    var slides = getSlides(track, cfg.slideSelector);
    if (slides.length < 1) return;
    var w = slides[0].offsetWidth;
    var dir = e.target.closest('[data-carousel-next]') ? 1 : -1;
    try {
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    } catch (err) {
      track.scrollLeft += dir * w;
    }
  }

  function alignInitialSlide(root, track, cfg) {
    var slides = getSlides(track, cfg.slideSelector);
    if (slides.length < 2) return;
    var idx = cfg.initialIndex;
    if (idx < 0) idx = 0;
    if (idx >= slides.length) idx = slides.length - 1;
    scrollToIndex(track, cfg.slideSelector, idx, false);
  }

  function scheduleAlignInitial(root, track, cfg) {
    function align() {
      alignInitialSlide(root, track, cfg);
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(align);
    });
    if (root._horizontalCarouselAlignTid) {
      clearTimeout(root._horizontalCarouselAlignTid);
    }
    root._horizontalCarouselAlignTid = setTimeout(align, 350);
  }

  window.initHorizontalCarousel = function (root) {
    if (!root || typeof root.querySelector !== 'function') return;
    var track = root.querySelector('[data-carousel-track]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    if (!track || !prevBtn || !nextBtn) return;
    var cfg = getConfig(root);
    var slides = getSlides(track, cfg.slideSelector);
    if (slides.length === 0) return;

    if (!boundRoots.has(root)) {
      boundRoots.add(root);
      root.addEventListener('click', cfg.simple ? onSimpleCarouselClick : onFeaturedCarouselClick);
    }

    if (!cfg.simple) {
      scheduleAlignInitial(root, track, cfg);
    }
  };

  window.initFeaturedCollectionCarousel = function (root) {
    window.initHorizontalCarousel(root);
  };
})();
